import { RouteObject } from 'react-router-dom'

import createRegistry from 'src/core/packages/registryFactory'

const createRouteRegistry = () => {
    const registry = createRegistry<RouteObject>()

    const registerRoute = (routeComponent: RouteObject) => {
        if (!Array.isArray(routeComponent.path)) {
            registry.add(routeComponent.path, routeComponent)
            return
        }

        routeComponent.path.forEach((p) => {
            registry.add(p, routeComponent)
        })

        return
    }

    const getRoutes = () => {
        return registry.keys().map((key) => registry.get(key))
    }

    return { registerRoute, getRoutes }
}

const routeRegistry = createRouteRegistry()

export const registerRoute = routeRegistry.registerRoute
export const getRoutes = routeRegistry.getRoutes
